import * as api from '../api';
import { userAPI } from '../config';
import AsyncButton from '../generic/forms/AsyncButton';
import useUser from '../login/userContext';
import type { Store } from '../model/types';
import { useAsyncAction } from '../utils/useAsyncAction';

export interface Props {
    store: Store;
}

export default function FavoriteStoreAction({ store }: Props) {
    const { showLoginModal, refreshUser, user } = useUser();

    const [setAsFavoriteStore] = useAsyncAction(async (store: { name: string }) => {
        if (showLoginModal()) {
            return;
        }
        await api.patchJson(userAPI.favouriteStoreURL(), { id: store.name });
        refreshUser();
    });

    const isFavoriteStore = store.name === user?.favouriteStore?.name;
    if (isFavoriteStore) {
        return (
            <span>
                Denne butikken er <a href="/my-account/store">ditt Vinmonopol</a>
            </span>
        );
    }
    return (
        <AsyncButton className="btn-secondary" onClick={() => setAsFavoriteStore(store)}>
            Lagre som mitt Vinmonopol
        </AsyncButton>
    );
}
